import type { SegmentRule } from "@/types/spyserp";

export const formatSegmentRulesSummary = (rules: SegmentRule): string => {
  const parts: string[] = [];
  if (rules.keywords?.length) {
    parts.push(`${rules.keywords.length} keywords`);
  }
  if (rules.tlds?.length) parts.push(`${rules.tlds.length} TLDs`);
  if (rules.locales?.length) parts.push(`${rules.locales.length} Locales`);
  return parts.length > 0 ? parts.join(", ") : "No rules";
};
